module.exports = __webpack_public_path__ + "2e50407806e5d1ecf1e2b78f05aa0415.png";